import { useState, PropsWithChildren, createContext, useEffect, useMemo } from 'react';
import { OriginalModal, ModalProps, initialModalProps } from './modal';

interface ModalContextProps {
  modalComponent: React.FC<ModalProps>;
}

export const ModalContext = createContext<ModalContextProps | undefined>(undefined);

export const ModalProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [props, setProps] = useState<PropsWithChildren<ModalProps>>(initialModalProps);

  const contextValue = useMemo(() => {
    const ModalProxy: React.FC<ModalProps> = (modalProps) => {
      useEffect(() => {
        if (modalProps.open) {
          setProps(modalProps);
          return;
        }
        setProps((prevProps) => {
          if (prevProps.id === modalProps.id && modalProps.open === false) {
            return initialModalProps;
          }
          return prevProps;
        });
      }, [modalProps]);

      return null;
    };

    return { modalComponent: ModalProxy };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.open]);

  return (
    <ModalContext.Provider value={contextValue}>
      {children}
      <OriginalModal {...props} setProps={setProps} />
    </ModalContext.Provider>
  );
};
